import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/api';
import type { FeedRestaurant, FeedRestaurantsResponse } from '../types/feed';

interface Params {
  lat?: number | null;
  lng?: number | null;
  token?: string | null;
  limit?: number;
  enabled?: boolean;
  venueId?: string | null;
}

export function useNearbyRestaurants({ lat, lng, token, limit = 8, enabled = true, venueId }: Params) {
  const [items, setItems] = useState<FeedRestaurant[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const ac = new AbortController();
    setLoading(true);
    const params: Record<string, string | number> = { limit };
    if (lat != null && lng != null) {
      params.lat = lat;
      params.lng = lng;
    }
    if (venueId) params.venueId = venueId;
    axios
      .get<FeedRestaurantsResponse>(`${API_URL || ''}/api/feed/restaurants`, {
        params,
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        signal: ac.signal,
      })
      .then((r) => setItems(r.data.items || []))
      .catch(() => { /* silent — strip just hides */ })
      .finally(() => setLoading(false));
    return () => ac.abort();
  }, [lat, lng, token, limit, enabled, venueId]);

  return { items, loading };
}
